var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMinusInCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M3 8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 0-1h-9A.5.5 0 0 0 3 8",
  clipRule: "evenodd"
})));
export { SvgMinusInCircleFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4QzE2IDEyLjQxODMgMTIuNDE4MyAxNiA4IDE2QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEMxMi40MTgzIDAgMTYgMy41ODE3MiAxNiA4Wk0zIDhDMyA4LjI3NjE0IDMuMjIzODYgOC41IDMuNSA4LjVIMTIuNUMxMi43NzYxIDguNSAxMyA4LjI3NjE0IDEzIDhDMTMgNy43MjM4NiAxMi43NzYxIDcuNSAxMi41IDcuNUgzLjVDMy4yMjM4NiA3LjUgMyA3LjcyMzg2IDMgOFoiIGZpbGw9IiMxQzFDMUEiLz4KPC9zdmc+Cg==";